import { GetAllAtributosObrasCadastroResponse } from "../../../data/daos/read/get_all_atributos_obras_cadastro";
import { IGetAllAtributosObrasCadastroUseCase } from "../../../presentation/useCases/read/get_all_atributos_obras_cadastro_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetAllAtributosObrasCadastroUseCase
 */

export class GetAllAtributosObrasCadastroUseCase implements IGetAllAtributosObrasCadastroUseCase {
  constructor(private readonly repository: IObrasRepository) {}

  async getAllAtributosObrasCadastro(): Promise<GetAllAtributosObrasCadastroResponse> {
    return await this.repository.getAllAtributosObrasCadastroList();
  }
}
